// L'AUDIOCONTEXT DELL'APPLICAZIONE
//
// Il problema che risolve. Lasciato a se stesso, Phaser crea un AudioContext per
// ogni istanza di gioco e lo CHIUDE quando la distruggi. In una SPA come questa,
// dove si entra e si esce dalla partita senza mai ricaricare la pagina, questo
// produce due guai:
//
//   1. Un AudioContext nuovo a ogni ingresso, e quelli vecchi chiusi. I browser
//      ne consentono un numero limitato per pagina (una manciata): dopo un po' di
//      partite l'audio smetterebbe di funzionare.
//
//   2. Gli errori "Cannot suspend/resume a closed AudioContext" in console.
//      Vengono da `WebAudioSoundManager.onGameVisible`, che alla comparsa della
//      pagina programma un `setTimeout(100)` e poi chiama `context.suspend()` e
//      `context.resume()` — senza controllare lo stato e senza `.catch()`. Se il
//      gioco viene distrutto entro quei 100 ms, il timer scatta su un contesto
//      ormai chiuso e le due promesse vengono rifiutate. Phaser rimuove il
//      listener in `destroy`, ma NON annulla il timer gia' programmato: non e'
//      una cosa che possiamo correggere dall'esterno.
//
// La soluzione e' non fargli mai chiudere il contesto. Passando `audio.context`
// nella configurazione, Phaser prende il ramo "contesto fornito dall'esterno":
// in `destroy` si limita a sospenderlo e alla creazione successiva lo riprende.
// Il contesto non e' mai chiuso, quindi quel timer non puo' piu' fallire.
// E' l'uso per cui l'opzione esiste — la documentazione di Phaser cita proprio
// il caso della SPA che non ricarica mai davvero la pagina.
//
// ATTENZIONE per chi tocchera' questo file: dato che ora il contesto sopravvive
// alla partita, tutto cio' che ci si attacca sopra va staccato a mano quando la
// scena si chiude. Prima ci pensava la chiusura del contesto a fare piazza
// pulita. Vedi `Synthesizer.destroy()`.

let sharedContext = null;

// Restituisce l'AudioContext dell'app, creandolo alla prima chiamata.
// Puo' restituire null sui browser senza Web Audio: in quel caso Phaser
// ripiega da solo sul suo gestore audio HTML5.
export function getAudioContext() {
  if (sharedContext && sharedContext.state !== 'closed') return sharedContext;

  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;

  sharedContext = new Ctor();
  return sharedContext;
}
